'use client';

import React from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import { bg0 } from '@osmosis/tailwind-ui/styles/background';
import DashboardSearch from './DashboardSearch';

type Props = {
  className?: string;
  dataTestId?: string;
  source: string;
};

/**
 * PublicHeroSearch renders the dashboard-style search input below public page heroes.
 */
const PublicHeroSearch = ({
  className,
  dataTestId = 'public-hero-search',
  source,
}: Props) => {
  return (
    <Box
      data-testid={dataTestId}
      className={cn(`w-full ${bg0} px-4 py-6`, className)}
    >
      <DashboardSearch
        centerSearch
        dataTestId={dataTestId}
        showAIButton={false}
        showTips={false}
        showTopicsDropdown={false}
        source={source}
      />
    </Box>
  );
};

export default PublicHeroSearch;
